var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEqTest(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 375 270",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 172.8,
    y: 43.75,
    width: 111.05,
    height: 160.98,
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-1"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -181.02,
    y: 165.99,
    width: 563.87,
    height: 74.9,
    transform: "translate(-24.37 14.03) rotate(-7.1)",
    style: {
      fill: "none"
    }
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M362,151c.45,.08,.88,.18,1.32,.28V41.92c0-8.88-7.19-16.07-16.07-16.07H27.98c-8.88,0-16.07,7.19-16.07,16.07V223.48c0,8.88,7.19,16.07,16.07,16.07H347.25c8.88,0,16.07-7.19,16.07-16.07v-59.7c-.53-3.53-.76-7.11-.32-10.78-.43,3.67-.21,7.25,.32,10.78v-12.51c-.44-.09-.87-.19-1.32-.28Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#clippath)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M212.63,170.06c6.53,6.87,15.45,7.07,22.01,.4l-10.04-19.27-11.97,18.87Z",
    style: {
      fill: "#e8f5f2",
      stroke: "#1a1a18",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.27,202.16l-13.33-41.53",
    style: {
      fill: "none",
      stroke: "#f3ca50",
      strokeMiterlimit: 10,
      strokeWidth: 7
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.17,202.23l6.47-41.36",
    style: {
      fill: "none",
      stroke: "#f3ca50",
      strokeMiterlimit: 10,
      strokeWidth: 7
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.18,144.16l-8.31-11.5c-1.12-1.55-2.44-2.95-3.92-4.15l-9.94-8.09",
    style: {
      fill: "none",
      stroke: "#f3ca50",
      strokeMiterlimit: 10,
      strokeWidth: 7
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.78,162.51l-5.56,.64c-10.28,1.18-19.5-6.39-20.42-16.76l-1.86-21.01,42.14-4.86,1.95,21.93c.89,10.02-6.32,18.92-16.24,20.06h0Z",
    style: {
      fill: "#e9725b",
      stroke: "#020203",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.83,123.27s3.12,3.18,6.24,3.28c4,.12,7.27-1.3,8.83-2.62,1.56-1.32,2.64-3.67,2.64-3.67l-17.71,3.01Z",
    style: {
      fill: "#757575",
      stroke: "#1a1a18",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.4,130.57c-.59,3.68-3.37,6.28-3.37,6.28,0,0-1.82-3.36-1.22-7.03,.59-3.68,2.1-6.49,3.37-6.28,1.27,.21,1.81,3.36,1.22,7.03h0Z",
    style: {
      fill: "#757575",
      stroke: "#1a1a18",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.21,126.34c2.69,2.55,3.29,6.32,3.29,6.32,0,0-3.78-.37-6.47-2.91-2.69-2.55-4.16-5.38-3.29-6.32,.88-.94,3.78,.36,6.47,2.91Z",
    style: {
      fill: "#757575",
      stroke: "#1a1a18",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.17,123.53l-1.21,5.82",
    style: {
      fill: "none",
      stroke: "#1a1a18",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.44,96.57c-14.47,1.67-24.83,14.81-23.18,29.38l26.18-3.02-3-26.36h0Z",
    style: {
      fill: "#b8d1b0",
      stroke: "#1a1a18",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.84,92.87v-.02l-36.62,3.76,2.99,26.26,36.11-3.71,.5-.06,21.55-2.48c-1.63-14.31-12.54-24.81-24.53-23.75h0Z",
    style: {
      fill: "#f3ca50",
      stroke: "#1a1a18",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.65,192.92c2.48-1.69,2.62-5.83,.33-9.25-2.3-3.42-6.17-4.83-8.65-3.14-2.48,1.69-2.63,5.83-.33,9.25,2.3,3.42,6.17,4.83,8.65,3.14Z",
    style: {
      fill: "#757575",
      stroke: "#1a1a18",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.93,185.24c.52-.04,1.09,.23,1.49,.53,1.07,.8,2.29,1.81,3.75,1.7,1.76-.15,5.23-2.49,6.88-3.02,2.5-.8,4.38,1.62,4.38,1.62l8.64,11.04-24.34,2.65s-1.83-12.17-1.83-12.19c-.07-.48-.11-1,.03-1.48,.08-.24,.21-.48,.41-.63,.18-.14,.39-.21,.6-.22h0Z",
    style: {
      fill: "#757575",
      stroke: "#1a1a18",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.27,187.15c.1-.01,.19-.08,.28-.12,.09-.04,.17-.09,.26-.15,0,0,.1-.12,.28-.27,.09-.07,.21-.12,.32-.21,.09-.07,.2-.15,.31-.24,.1-.07,.19-.17,.3-.25,.11-.08,.23-.12,.34-.19,.11-.07,.23-.12,.34-.19,.11-.07,.21-.15,.32-.22,.12-.07,.23-.14,.34-.19,.12-.06,.24-.11,.35-.15,.12-.05,.23-.11,.34-.15,.12-.04,.24-.1,.35-.14,.13-.04,.26-.04,.37-.06,.14-.03,.26-.04,.37-.06,.23-.03,.35-.03,.36-.03,.12,0,.24-.05,.35-.08,.11-.03,.24-.05,.33-.11,.1-.06,.2-.14,.27-.23,.07-.09,.13-.2,.17-.31,.04-.11,.06-.23,.07-.35,0-.12-.05-.23-.08-.34-.03-.11-.08-.22-.14-.31-.06-.1-.1-.22-.19-.3-.09-.07-.2-.14-.31-.19-.11-.04-.23-.04-.35-.05-.04,0-.17,.02-.4,.04-.11,0-.25-.02-.41,0-.12,.02-.24,.09-.39,.12-.12,.03-.26,0-.4,.03-.12,.03-.23,.13-.37,.17-.12,.04-.26,.05-.39,.09-.12,.04-.24,.12-.37,.18-.11,.04-.25,.03-.37,.09-.11,.05-.2,.14-.32,.21-.11,.06-.22,.11-.33,.18-.11,.07-.22,.12-.33,.18s-.2,.16-.3,.23c-.1,.07-.19,.17-.29,.24-.1,.07-.21,.14-.31,.21-.11,.08-.2,.15-.3,.23-.11,.08-.23,.12-.33,.2-.12,.09-.22,.15-.31,.22-.17,.14-.27,.24-.28,.25-.09,.08-.14,.18-.2,.28-.06,.1-.11,.2-.14,.31-.03,.11-.07,.23-.07,.34,0,.12,.05,.23,.09,.34,.04,.11,.08,.22,.15,.32,.09,.1,.18,.2,.29,.27,.11,.07,.24,.1,.37,.12,.13,.03,.26,.06,.39,.04v-.02Z",
    style: {
      fill: "#e8f5f2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.27,187.15c.1-.01,.19-.08,.28-.12,.09-.04,.17-.09,.26-.15,0,0,.1-.12,.28-.27,.09-.07,.21-.12,.32-.21,.09-.07,.2-.15,.31-.24,.1-.07,.19-.17,.3-.25,.11-.08,.23-.12,.34-.19,.11-.07,.23-.12,.34-.19,.11-.07,.21-.15,.32-.22,.12-.07,.23-.14,.34-.19,.12-.06,.24-.11,.35-.15,.12-.05,.23-.11,.34-.15,.12-.04,.24-.1,.35-.14,.13-.04,.26-.04,.37-.06,.14-.03,.26-.04,.37-.06,.23-.03,.35-.03,.36-.03,.12,0,.24-.05,.35-.08,.11-.03,.24-.05,.33-.11,.1-.06,.2-.14,.27-.23,.07-.09,.13-.2,.17-.31,.04-.11,.06-.23,.07-.35,0-.12-.05-.23-.08-.34-.03-.11-.08-.22-.14-.31-.06-.1-.1-.22-.19-.3-.09-.07-.2-.14-.31-.19-.11-.04-.23-.04-.35-.05-.04,0-.17,.02-.4,.04-.11,0-.25-.02-.41,0-.12,.02-.24,.09-.39,.12-.12,.03-.26,0-.4,.03-.12,.03-.23,.13-.37,.17-.12,.04-.26,.05-.39,.09-.12,.04-.24,.12-.37,.18-.11,.04-.25,.03-.37,.09-.11,.05-.2,.14-.32,.21-.11,.06-.22,.11-.33,.18-.11,.07-.22,.12-.33,.18s-.2,.16-.3,.23c-.1,.07-.19,.17-.29,.24-.1,.07-.21,.14-.31,.21-.11,.08-.2,.15-.3,.23-.11,.08-.23,.12-.33,.2-.12,.09-.22,.15-.31,.22-.17,.14-.27,.24-.28,.25-.09,.08-.14,.18-.2,.28-.06,.1-.11,.2-.14,.31-.03,.11-.07,.23-.07,.34,0,.12,.05,.23,.09,.34,.04,.11,.08,.22,.15,.32,.09,.1,.18,.2,.29,.27,.11,.07,.24,.1,.37,.12,.13,.03,.26,.06,.39,.04v-.02Z",
    style: {
      fill: "none",
      stroke: "#1a1a18",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.54,183.96c6.69-1.02,12.92,3.61,13.93,10.35l-24.21,3.69c-1.01-6.73,3.59-13.01,10.27-14.03h0Z",
    style: {
      fill: "#f2f2f2",
      stroke: "#1a1a18",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.8,184.22c5.55,.04,10.46,4.37,11.45,10.38",
    style: {
      fill: "none",
      stroke: "#1a1a18",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.35,184.27c.35,.06,.69,.22,1.03,.41,.3,.18,.58,.41,.87,.68,.26,.24,.53,.49,.78,.79,.22,.27,.44,.58,.65,.9,.2,.3,.36,.64,.54,.97,.17,.32,.33,.65,.49,1,.15,.33,.28,.68,.42,1.03,.14,.36,.31,.67,.43,1.03,.12,.36,.23,.7,.34,1.07,.11,.36,.19,.72,.28,1.08,.09,.36,.15,.73,.22,1.1,.07,.37,.16,.72,.21,1.1",
    style: {
      fill: "none",
      stroke: "#1a1a18",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.89,184.33c-.06,.19,.09,.58,.1,1.1,0,.31-.07,.68-.05,1.09,.02,.33-.02,.7,0,1.09,.03,.34,.13,.7,.17,1.08,.03,.35,.12,.7,.16,1.08,.04,.35-.12,.74-.08,1.11,.04,.35,.13,.71,.17,1.08,.05,.37,.08,.72,.12,1.09,.05,.37,.09,.72,.14,1.09,.05,.37,.14,.71,.19,1.08,.05,.37,.07,.72,.12,1.09",
    style: {
      fill: "none",
      stroke: "#1a1a18",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.54,184.34c-.33,.14-.66,.33-.96,.55-.3,.22-.4,.62-.65,.9-.24,.26-.54,.47-.75,.79-.2,.3-.49,.55-.65,.89-.16,.32-.28,.67-.41,1.02-.13,.33-.06,.74-.16,1.1-.1,.36-.17,.69-.25,1.06-.07,.37-.25,.69-.3,1.06-.05,.37-.29,.7-.32,1.07-.03,.37,.11,.74,.1,1.11,0,.37-.11,.73-.09,1.1,.02,.37,.09,.73,.13,1.1,.03,.37,0,.74,.05,1.11",
    style: {
      fill: "none",
      stroke: "#1a1a18",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.36,204.12l36.64-5.58-.66-4.36-36.64,5.58,.66,4.36Z",
    style: {
      fill: "#f2f2f2",
      stroke: "#1a1a18",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.32,191.93c1.79-3.72,1.05-7.8-1.64-9.11-2.69-1.31-6.32,.64-8.11,4.36-1.79,3.72-1.05,7.8,1.64,9.11,2.69,1.31,6.32-.64,8.11-4.36Z",
    style: {
      fill: "#757575",
      stroke: "#1a1a18",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.6,185.41c-.52,.03-1.05,.39-1.39,.73-.95,.95-2.01,2.13-3.47,2.22-1.76,.11-5.53-1.71-7.24-1.99-2.59-.43-4.1,2.24-4.1,2.24l-6.98,12.17,24.47-.89s.08-12.31,.08-12.33c0-.49-.03-1.01-.24-1.45-.11-.23-.28-.44-.5-.57-.2-.11-.41-.15-.63-.14h0Z",
    style: {
      fill: "#757575",
      stroke: "#1a1a18",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.7,189.6c-.1,0-.2,.03-.29,0s-.2-.05-.28-.1c0,0-.09-.14-.3-.25-.1-.06-.22-.1-.35-.18-.11-.06-.24-.09-.36-.15-.11-.06-.2-.17-.32-.23-.12-.06-.25-.09-.36-.14s-.23-.11-.35-.16c-.12-.05-.25-.09-.36-.14-.12-.05-.23-.13-.35-.17-.13-.05-.26-.09-.37-.11-.13-.03-.26-.02-.37-.04-.13-.03-.24-.09-.36-.11-.14-.02-.26,0-.37,0-.15-.01-.27-.06-.37-.06-.24,0-.36,.04-.37,.04-.12,.02-.23,.03-.35,.02-.11-.01-.23-.05-.33-.1-.11-.05-.22-.09-.3-.18-.09-.08-.14-.18-.2-.29-.06-.1-.12-.21-.14-.32-.03-.12,.01-.24,.03-.36,.01-.12,.06-.22,.11-.33,.05-.11,.1-.21,.18-.29,.08-.09,.15-.19,.25-.25,.1-.06,.23-.07,.34-.09,.03,0,.17-.04,.4-.06,.11,0,.25,0,.4,0,.12,0,.26,0,.4,.01,.12,0,.26-.03,.4,0,.12,.01,.26,.04,.4,.06,.13,.02,.26,.06,.4,.08,.13,.03,.26,.05,.4,.08,.11,.03,.23,.08,.35,.12,.12,.04,.22,.11,.35,.15,.12,.04,.26,.03,.38,.08,.12,.05,.21,.15,.32,.2s.25,.06,.37,.11c.11,.06,.23,.1,.35,.15,.11,.06,.23,.12,.34,.18,.11,.06,.2,.19,.3,.24,.12,.06,.26,.07,.36,.12,.12,.07,.21,.18,.3,.24,.19,.11,.35,.12,.36,.13,.1,.06,.15,.19,.22,.28,.07,.09,.14,.18,.19,.29,.05,.11,.14,.21,.15,.33,0,.12-.06,.23-.09,.35-.03,.12-.05,.22-.11,.32-.07,.12-.12,.24-.22,.32-.1,.08-.23,.12-.35,.16-.12,.04-.24,.06-.38,.05h0Z",
    style: {
      fill: "#e8f5f2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.7,189.6c-.1,0-.2,.03-.29,0s-.2-.05-.28-.1c0,0-.09-.14-.3-.25-.1-.06-.22-.1-.35-.18-.11-.06-.24-.09-.36-.15-.11-.06-.2-.17-.32-.23-.12-.06-.25-.09-.36-.14s-.23-.11-.35-.16c-.12-.05-.25-.09-.36-.14-.12-.05-.23-.13-.35-.17-.13-.05-.26-.09-.37-.11-.13-.03-.26-.02-.37-.04-.13-.03-.24-.09-.36-.11-.14-.02-.26,0-.37,0-.15-.01-.27-.06-.37-.06-.24,0-.36,.04-.37,.04-.12,.02-.23,.03-.35,.02-.11-.01-.23-.05-.33-.1-.11-.05-.22-.09-.3-.18-.09-.08-.14-.18-.2-.29-.06-.1-.12-.21-.14-.32-.03-.12,.01-.24,.03-.36,.01-.12,.06-.22,.11-.33,.05-.11,.1-.21,.18-.29,.08-.09,.15-.19,.25-.25,.1-.06,.23-.07,.34-.09,.03,0,.17-.04,.4-.06,.11,0,.25,0,.4,0,.12,0,.26,0,.4,.01,.12,0,.26-.03,.4,0,.12,.01,.26,.04,.4,.06,.13,.02,.26,.06,.4,.08,.13,.03,.26,.05,.4,.08,.11,.03,.23,.08,.35,.12,.12,.04,.22,.11,.35,.15,.12,.04,.26,.03,.38,.08,.12,.05,.21,.15,.32,.2s.25,.06,.37,.11c.11,.06,.23,.1,.35,.15,.11,.06,.23,.12,.34,.18,.11,.06,.2,.19,.3,.24,.12,.06,.26,.07,.36,.12,.12,.07,.21,.18,.3,.24,.19,.11,.35,.12,.36,.13,.1,.06,.15,.19,.22,.28,.07,.09,.14,.18,.19,.29,.05,.11,.14,.21,.15,.33,0,.12-.06,.23-.09,.35-.03,.12-.05,.22-.11,.32-.07,.12-.12,.24-.22,.32-.1,.08-.23,.12-.35,.16-.12,.04-.24,.06-.38,.05h0Z",
    style: {
      fill: "none",
      stroke: "#1a1a18",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.04,187.42c-6.76-.04-12.28,5.44-12.32,12.25l24.48,.15c.04-6.81-5.4-12.36-12.16-12.41h0Z",
    style: {
      fill: "#f2f2f2",
      stroke: "#1a1a18",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.81,187.56c-5.48,.85-9.73,5.84-9.86,11.93",
    style: {
      fill: "none",
      stroke: "#1a1a18",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.23,187.57c-.33,.11-.64,.31-.95,.56-.27,.21-.56,.45-.81,.76-.22,.27-.43,.58-.63,.92-.18,.3-.3,.66-.46,1.02-.15,.33-.28,.67-.42,1.03-.12,.34-.31,.67-.41,1.04-.1,.35-.15,.72-.24,1.09-.09,.37-.13,.72-.2,1.1-.07,.37-.16,.72-.21,1.1-.05,.38-.16,.72-.2,1.1-.03,.38,.04,.75,.02,1.12-.02,.38-.09,.74-.1,1.12",
    style: {
      fill: "none",
      stroke: "#1a1a18",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.56,187.6c.09,.19,.29,.5,.36,1.02,.04,.31,.14,.67,.18,1.09,.03,.33-.09,.71-.06,1.1,.02,.34,.05,.71,.07,1.09,.02,.35-.05,.72-.03,1.09,.01,.35,.25,.71,.26,1.09,0,.36-.1,.72-.09,1.1,0,.38,.14,.72,.14,1.09,0,.37-.1,.72-.1,1.09,0,.37,.05,.72,.05,1.1s-.12,.72-.12,1.1",
    style: {
      fill: "none",
      stroke: "#1a1a18",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.02,187.72c.35,.09,.66,.18,.99,.36,.33,.18,.55,.4,.84,.64,.27,.22,.66,.33,.91,.61,.23,.26,.45,.56,.66,.87,.2,.29,.45,.57,.63,.9,.17,.31,.24,.69,.39,1.03,.15,.34,.43,.61,.56,.96,.13,.35,.1,.73,.2,1.09,.1,.36,.27,.68,.35,1.04,.08,.37,.25,.7,.31,1.06,.06,.36-.17,.75-.13,1.12,.04,.37,.35,.7,.37,1.07,.02,.37,.02,.74,.02,1.11",
    style: {
      fill: "none",
      stroke: "#1a1a18",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.9,199.89l-37.06-.23-.03,4.41,37.06,.23,.03-4.41Z",
    style: {
      fill: "#f2f2f2",
      stroke: "#1a1a18",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.76,114.7c3.53,0,6.4-2.88,6.4-6.44s-2.86-6.44-6.4-6.44-6.4,2.88-6.4,6.44,2.86,6.44,6.4,6.44Z",
    style: {
      fill: "#fff",
      stroke: "#1a1a18",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.76,111.42c1.73,0,3.14-1.42,3.14-3.16s-1.41-3.16-3.14-3.16-3.14,1.42-3.14,3.16,1.41,3.16,3.14,3.16Z",
    style: {
      fill: "#1a1a18"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.32,120.52c0,7.88,1.28,16.3,4.37,17.07,3.72,.94,7.4-3.06,11.91-4.59",
    style: {
      fill: "none",
      stroke: "#f3ca50",
      strokeMiterlimit: 10,
      strokeWidth: 7
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.24,105.88c-.08-2.3-5.51-1.37-8.41-.48-.69,.21-1.85,.49-2.57,.62-1.14,.2-2.29,.38-3.43,.54-3.1,.44-6.34,.14-9.35,1.16-1.45,.49-2.97,1.26-3.91,2.48-1.03,1.34-1.86,2.87-2.8,4.29-.95,1.44-1.45,4.85-1.13,6.57,.46,2.4,.17,2.68,4.4,2.03,1.42-.22,3.67-.87,4.25-1.13,.09-1.35-.38-3.05-.44-4.41-.03-.74-.02-2.02,.82-2.26,.6-.17,1.38,.45,1.96,.56,.83,.15,1.68,.16,2.51,.07,1.78-.19,3.24-1.74,4.07-2.85,.39-.52,1.12-.63,1.65-.25,.65,.47,1.26,.95,1.26,.95,0,0-2.19,.6-2.32,1.6-.24,1.91,1.36,1.39,1.36,1.39,1.18-.18,2.4-.3,3.55-.64,.28-.08,.53-.23,.72-.44,.19-.21,.3-.44,.36-.69l.09,.18c.42-.01,1.55-.89,1.65-1.47,.02-.12,.03-.23,.04-.34l.12,.16c.42-.16,1.36-.8,1.46-1.38,.21-1.21-.64-2.62-1.57-3.33-.45-.35-.95-.61-1.48-.78l.3-.11c3.01-1.39,6.89-.85,6.85-2.04h0Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.87,115.18c.42-.01,1.55-.89,1.65-1.47,.25-1.43-.46-2.88-1.63-3.69-.15-.11-.32-.21-.48-.3-.45-.25-.94-.41-1.41-.64-.44-.21-.92-.36-1.4-.44",
    style: {
      fill: "none",
      stroke: "#1a1a18",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.87,109.96c1.33,.39,2.78,.98,3.8,2.09,.65,.71,1.32,1.95,1.11,2.93-.06,.25-.17,.49-.36,.7-.19,.21-.44,.36-.72,.44-1.15,.34-2.37,.46-3.55,.64,0,0-1.6,.52-1.36-1.39,.13-1,2.32-1.6,2.32-1.6,0,0-.61-.48-1.26-.95-.53-.38-1.27-.25-1.66,.27-1.61,2.15-3.85,3.26-6.56,2.75-.34-.06-.96-.25-1.42-.39-.32-.1-.66,.05-.81,.35-.25,.51-.2,1.37-.18,1.83,.06,1.36,.22,3.15,.13,4.5-.65,.55-2.91,1.02-4.33,1.24-4.23,.65-3.92,.08-4.37-2.32-.32-1.71,.32-4.73,1.13-6.57,.68-1.56,1.76-2.94,2.8-4.29,.94-1.22,2.46-2,3.91-2.48,3.01-1.02,6.24-.72,9.34-1.16,1.17-.17,2.34-.35,3.51-.55,.69-.12,1.81-.39,2.49-.61,2.9-.89,7.76-1.97,8.41,.16,.35,1.15-3.84,.97-6.85,2.36",
    style: {
      fill: "none",
      stroke: "#1a1a18",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.5,107.53c.38,0,.76,.09,1.13,.17,.33,.07,.66,.12,.99,.2,.72,.17,1.36,.47,1.95,.92,.93,.72,1.78,2.12,1.57,3.33-.1,.58-1.04,1.22-1.46,1.38",
    style: {
      fill: "none",
      stroke: "#1a1a18",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.92,116.6c.32,1.17-1.31,2.49-3.64,2.94-2.33,.45-4.49-.12-4.81-1.3-.32-1.17,1.46-.24,3.8-.69,2.34-.45,4.33-2.12,4.65-.95Z",
    style: {
      fill: "#e05c69",
      stroke: "#1a1a18",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.33,162.57c-.45,.19-1.04,.11-1.5-.32-.3-.29-.52-.66-.72-1.02-.62-1.12-1.65-1.94-2.17-3.11-.57-1.27-.85-2.99-.68-4.36,.12-1.03,.75-1.97,.03-2.94l-3.26-2.77s.2-2.6,1.92-4.18c1.72-1.57,4.2-2.83,4.2-2.83l2.45,2.9s3.81,3.54,6.68,4.81c.84,.38,2.99,.38,4.07,.78,.98,.36,1.73,1.45,2.36,2.04,.64,.6,.57,1.46-.32,1.66-.89,.21-2.23-1.33-2.44-1.45-.73-.39-3.24-.5-3.55-.54",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.33,162.57c-.45,.19-1.04,.11-1.5-.32-.3-.29-.52-.66-.72-1.02-.62-1.12-1.65-1.94-2.17-3.11-.57-1.27-.85-2.99-.68-4.36,.12-1.03,.75-1.97,.03-2.94l-3.26-2.77s.2-2.6,1.92-4.18c1.72-1.57,4.2-2.83,4.2-2.83l2.45,2.9s3.81,3.54,6.68,4.81c.84,.38,2.99,.38,4.07,.78,.98,.36,1.73,1.45,2.36,2.04,.64,.6,.57,1.46-.32,1.66-.89,.21-2.23-1.33-2.44-1.45-.73-.39-3.24-.5-3.55-.54",
    style: {
      fill: "none",
      stroke: "#1a1a18",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.53,150.97c.47,.17,.62,.19,.88,.31,1.03,.49,1.6,1.03,2.33,1.57,1.8,1.32,2.62,3.05,2.59,3.91,0,0-.05,.88-1.01,1.1",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.53,150.97c.47,.17,.62,.19,.88,.31,1.03,.49,1.6,1.03,2.33,1.57,1.8,1.32,2.62,3.05,2.59,3.91,0,0-.05,.88-1.01,1.1",
    style: {
      fill: "none",
      stroke: "#1a1a18",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.18,152.27c.66,.18,1.49,.76,3.17,2.23,1.49,1.3,3.71,4.97,2.48,5.95,0,0-.71,.52-1.37,.35",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.18,152.27c.66,.18,1.49,.76,3.17,2.23,1.49,1.3,3.71,4.97,2.48,5.95,0,0-.71,.52-1.37,.35",
    style: {
      fill: "none",
      stroke: "#1a1a18",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.33,162.57c.45-.19,.78-.64,.7-1.29-.13-1.1-1.34-2.61-1.23-3.73,.1-1.01,.87-.68,.87-.68,2.61,1.28,3.73,.97,4.67,3.13,.66,1.5,3.03,3.3,3.65,1.64,.37-.98-.86-3.61-1.62-4.6-.99-1.29-2.58-2.03-3.75-3.15",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.33,162.57c.45-.19,.78-.64,.7-1.29-.13-1.1-1.34-2.61-1.23-3.73,.1-1.01,.87-.68,.87-.68,2.61,1.28,3.73,.97,4.67,3.13,.66,1.5,3.03,3.3,3.65,1.64,.37-.98-.86-3.61-1.62-4.6-.99-1.29-2.58-2.03-3.75-3.15",
    style: {
      fill: "none",
      stroke: "#1a1a18",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.82,45.34c-1.58-.15-3.04,.1-4.38,.75-1.34,.65-2.54,1.51-3.6,2.57-.81-1.28-1.81-2.36-3-3.23-1.19-.88-2.57-1.39-4.15-1.54-1.1-.11-2.14,.02-3.11,.38-.97,.36-1.82,.88-2.57,1.56-.74,.68-1.34,1.48-1.81,2.41-.46,.93-.75,1.91-.85,2.97-.11,1.13,0,2.14,.29,3.03,.3,.89,.68,1.74,1.12,2.54l10.42,15.33c.59,.7,1.04,1.06,1.34,1.09,.3,.03,.81-.24,1.53-.82l13.14-13.07c.66-.7,1.21-1.45,1.63-2.27,.43-.82,.69-1.79,.8-2.93,.1-1.05,0-2.08-.28-3.08-.28-1-.72-1.9-1.32-2.71-.6-.81-1.34-1.48-2.22-2.02-.88-.54-1.88-.86-2.98-.96h0Z",
    style: {
      fill: "#e9725b",
      stroke: "#020203",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.85,81.99c-.4,.1-.73,.28-1,.56-.27,.27-.49,.58-.66,.93-.31-.24-.64-.42-1-.53-.36-.11-.74-.12-1.14-.02-.28,.07-.52,.19-.72,.36-.2,.17-.37,.37-.49,.6-.12,.23-.2,.48-.24,.74-.03,.27-.02,.53,.05,.79,.07,.28,.18,.52,.33,.71,.15,.19,.31,.36,.49,.52l3.83,2.82c.2,.12,.34,.17,.42,.15,.08-.02,.17-.13,.3-.33l2.08-4.3c.1-.23,.17-.45,.2-.69,.03-.24,.02-.49-.06-.78-.06-.26-.17-.51-.33-.72-.15-.22-.34-.4-.55-.54-.21-.15-.45-.24-.71-.3-.26-.06-.53-.05-.8,.02h0Z",
    style: {
      fill: "#f3ca50",
      stroke: "#020203",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.63,71.46c-.71-.14-1.38-.1-2.02,.13-.64,.23-1.23,.56-1.76,1-.31-.62-.7-1.16-1.19-1.62-.49-.46-1.09-.75-1.8-.9-.49-.1-.97-.09-1.42,.03-.46,.12-.87,.31-1.24,.59-.37,.27-.68,.61-.94,1.01-.26,.4-.44,.83-.53,1.31-.11,.51-.11,.97-.02,1.4,.09,.42,.22,.83,.38,1.21l3.94,7.48c.23,.35,.41,.53,.55,.56,.14,.03,.38-.07,.73-.3l6.59-5.33c.34-.29,.62-.6,.85-.96,.23-.35,.4-.78,.5-1.29,.1-.47,.11-.95,.03-1.41-.08-.47-.23-.9-.46-1.3-.23-.4-.53-.74-.91-1.02-.37-.29-.81-.48-1.3-.58h0Z",
    style: {
      fill: "#90c4a2",
      stroke: "#020203",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#clippath-1)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M347.2,197.24c-11.43,3.22-22.96,6.12-34.59,8.65-11.63,2.47-23.35,4.6-35.12,6.39-11.77,1.77-23.59,3.14-35.44,4.23-11.84,1.1-23.71,1.82-35.58,2.26-11.87,.44-23.73,.62-35.58,.51-23.69-.22-47.32-1.4-70.83-3.2-23.51-1.8-46.91-4.19-70.26-6.58-5.82-.59-11.64-1.18-17.45-1.76,.16,2.26,.3,4.52,.39,6.78,5.33,.53,10.65,1.07,15.99,1.62,23.35,2.4,46.83,4.79,70.48,6.6,23.64,1.82,47.46,3.01,71.39,3.23,11.97,.11,23.96-.07,35.97-.52,12.01-.45,24.02-1.17,36.02-2.29,12-1.11,23.99-2.5,35.93-4.29,11.94-1.81,23.83-3.97,35.65-6.48,11.8-2.57,23.51-5.51,35.13-8.78,4.64-1.34,9.26-2.75,13.86-4.21-.02-2.33-.05-4.67-.08-7-5.27,1.69-10.56,3.32-15.88,4.85Z",
    style: {
      fill: "#e9725b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.06,190.88c-11.24,3.17-22.59,6.02-34.04,8.51-11.46,2.43-23,4.53-34.6,6.3-11.6,1.74-23.26,3.1-34.95,4.18-11.69,1.09-23.41,1.79-35.13,2.23-11.72,.44-23.46,.61-35.19,.51-23.46-.22-46.89-1.38-70.26-3.17-23.38-1.78-46.69-4.16-70.05-6.56-6.3-.64-12.61-1.28-18.93-1.91,.12,2.27,.28,4.53,.44,6.8,5.81,.58,11.61,1.17,17.42,1.76,23.35,2.4,46.75,4.78,70.26,6.58,23.51,1.8,47.13,2.98,70.83,3.2,11.85,.1,23.71-.08,35.58-.52,11.87-.45,23.73-1.17,35.58-2.27,11.85-1.1,23.67-2.47,35.44-4.24,11.77-1.79,23.48-3.92,35.12-6.39,11.62-2.53,23.16-5.43,34.59-8.65,5.33-1.53,10.64-3.17,15.91-4.86-.04-2.34-.07-4.68-.11-7.02-5.93,1.94-11.9,3.79-17.91,5.52Z",
    style: {
      fill: "#b8dee3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.98,184.56c-11.07,3.11-22.24,5.93-33.51,8.38-11.28,2.39-22.65,4.46-34.07,6.2-11.43,1.72-22.93,3.05-34.46,4.12-11.53,1.08-23.1,1.77-34.69,2.21-11.59,.43-23.19,.61-34.8,.5-23.23-.21-46.46-1.37-69.7-3.15-23.24-1.77-46.47-4.14-69.83-6.54-6.7-.68-13.42-1.37-20.15-2.03-.03,2.26,.04,4.52,.15,6.77,6.31,.63,12.62,1.27,18.92,1.91,23.35,2.39,46.67,4.77,70.05,6.56,23.37,1.79,46.8,2.95,70.27,3.17,11.72,.1,23.46-.07,35.19-.51,11.72-.44,23.45-1.15,35.13-2.23,11.69-1.08,23.35-2.43,34.95-4.18,11.6-1.77,23.13-3.86,34.6-6.3,11.45-2.49,22.8-5.34,34.05-8.51,6.01-1.73,11.97-3.58,17.9-5.51-.03-2.35-.06-4.69-.06-7.04-6.6,2.19-13.24,4.27-19.94,6.2Z",
    style: {
      fill: "#febd02"
    }
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEqTest);
export default __webpack_public_path__ + "static/media/EQTest.78a0ae5b221f4258ae5c7c037f77c27a.svg";
export { ForwardRef as ReactComponent };